import { fixIndent } from './fix-indent';
import ace from 'ace-builds';
let nextId = 1;
export class TemplateCodeBlock {
    append(target, original) {
        const id = 'editor-' + (nextId++);
        const text = fixIndent(original.innerText);
        const div = document.createElement('div');
        div.id = id;
        div.className = 'code-sample';
        target.appendChild(div);
        const editor = ace.edit(id);
        editor.setValue(text);
        editor.setReadOnly(true);
        editor.setTheme('ace/theme/cobalt');
        editor.setShowPrintMargin(false);
        editor.setOptions({
            maxLines: Infinity,
            highlightActiveLine: false,
            highlightGutterLine: false,
            fontSize: '16px',
        });
        editor.session.setMode('ace/mode/python');
        editor.session.selection.clearSelection();
        editor.renderer.setShowGutter(false);
    }
}
